import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
    {
        title: 'Operatorul',
        text: 'SC EVOO MEDICAL SRL, mun. Sebeș, loc. componentă Petrești, str. 1 Mai nr. 294, jud. Alba, cod poștal 515850, CUI 39926229 (cod de TVA RO39926229). Responsabilul cu protecția datelor poate fi contactat la gdpr@evoomedical.ro sau prin poștă, la sediu, cu mențiunea „Protecția datelor”.'
    },
    {
        title: 'Ce date prelucrăm și de ce',
        table: {
            head: ['Pentru ce', 'Ce date', 'Temeiul legal'],
            rows: [
                ['Programarea și evidența pacienților', 'nume, telefon, e-mail, data nașterii, specialitatea și ora aleasă', 'art. 6 alin. (1) lit. b) RGPD — pașii necesari înaintea și în executarea contractului de servicii medicale'],
                ['Consultația, investigațiile, tratamentul și dosarul medical', 'datele de identificare, inclusiv CNP-ul, și datele privind sănătatea', 'art. 6 alin. (1) lit. b) și c) și art. 9 alin. (2) lit. h) RGPD; Legea nr. 46/2003; Legea nr. 95/2006'],
                ['Facturarea și evidența contabilă', 'nume, adresă, serviciul, suma', 'art. 6 alin. (1) lit. c) RGPD; Legea contabilității nr. 82/1991; Codul fiscal'],
                ['Contul de pacient de pe site', 'e-mail, parolă (criptată), datele de profil', 'art. 6 alin. (1) lit. b) RGPD'],
                ['Mesajele trimise prin formularul de contact', 'nume, contact, mesajul', 'art. 6 alin. (1) lit. f) RGPD — interesul nostru de a vă răspunde'],
                ['Măsurarea folosirii site-ului (statistici)', 'date despre navigare, prin cookie-uri de analiză', 'art. 6 alin. (1) lit. a) RGPD — numai cu acordul dumneavoastră'],
                ['Informări despre servicii noi și campanii de prevenție', 'nume, e-mail sau telefon', 'art. 6 alin. (1) lit. a) RGPD — numai cu acord separat, retras oricând'],
                ['Recrutarea medicilor și a personalului', 'datele din candidatură', 'art. 6 alin. (1) lit. b) RGPD; acord separat pentru păstrarea în baza de candidați'],
                ['Siguranța persoanelor și a bunurilor (supraveghere video)', 'imaginea, în zonele de acces și circulație', 'art. 6 alin. (1) lit. f) RGPD; Legea nr. 190/2018, art. 5']
            ]
        }
    },
    {
        title: 'Cine are acces la date',
        items: [
            'Medicii care vă tratează și personalul medical al clinicii, fiecare numai cât are nevoie pentru actul medical. Fiecare acces la dosarul electronic se înregistrează.',
            'Medicii colaboratori, care lucrează în clinică pe baza unui contract ce le impune aceleași obligații de confidențialitate.',
            'Laboratoarele și centrele de imagistică partenere, numai pentru investigațiile pe care le cereți.',
            'Furnizorii noștri de servicii — programul informatic medical, găzduirea site-ului, contabilitatea, mentenanța — care lucrează numai la instrucțiunile noastre, pe bază de contract.',
            'Autoritățile publice, numai când legea ne obligă.',
            'Nu vindem și nu închiriem datele nimănui.'
        ]
    },
    {
        title: 'Transferuri în afara Uniunii Europene',
        text: 'Statisticile site-ului se fac cu Google Analytics (Google Ireland Limited) și autentificarea în cont cu serviciile Microsoft. Aceste companii pot transfera date în Statele Unite, în baza Cadrului UE–SUA privind protecția datelor (Data Privacy Framework) sau a clauzelor contractuale standard aprobate de Comisia Europeană. Datele medicale nu se transferă în afara Spațiului Economic European.'
    },
    {
        title: 'Cât timp păstrăm datele',
        table: {
            head: ['Datele', 'Durata'],
            rows: [
                ['Documentele medicale', 'durata prevăzută de legislația sanitară și arhivistică, potrivit nomenclatorului arhivistic al clinicii'],
                ['Documentele financiar-contabile', '5 ani, respectiv 10 ani pentru registre (Legea nr. 82/1991)'],
                ['Contul de pacient', 'până la închiderea lui; un cont nefolosit 3 ani se închide, după o înștiințare prealabilă'],
                ['Mesajele din formularul de contact', '12 luni de la ultimul mesaj'],
                ['Candidaturile', '6 luni după încheierea selecției; 2 ani, numai cu acordul dumneavoastră'],
                ['Înregistrările video', 'cel mult 30 de zile, cu excepția celor păstrate pentru un incident'],
                ['Acordul pentru informări', 'până la retragerea lui']
            ]
        }
    },
    {
        title: 'Drepturile dumneavoastră',
        text: 'Puteți cere oricând: accesul la date și o copie a lor; corectarea datelor greșite; ștergerea, când legea o permite (documentele medicale nu se pot șterge înainte de termenul legal); restricționarea prelucrării; portabilitatea datelor date de dumneavoastră; vă puteți opune prelucrării bazate pe interesul nostru legitim și puteți retrage oricând un acord, fără să afectați ce s-a făcut până atunci. Cererea o trimiteți la gdpr@evoomedical.ro; răspundem în cel mult o lună. Vă puteți plânge oricând la ANSPDCP — www.dataprotection.ro, B-dul G-ral Gheorghe Magheru nr. 28–30, sector 1, București.'
    },
    {
        title: 'Decizii automate',
        text: 'Nu luăm decizii bazate exclusiv pe prelucrarea automată care să aibă efecte juridice asupra dumneavoastră. În recrutare, punctajul calculat de formular ordonează candidaturile; decizia o ia întotdeauna un om.'
    },
    {
        title: 'Securitatea',
        text: 'Datele medicale se păstrează în programul informatic medical, cu acces pe bază de cont și parolă, drepturi pe roluri și jurnalizarea accesului. Personalul semnează angajamente de confidențialitate și este instruit anual.'
    },
    {
        title: 'Modificări',
        text: 'Publicăm orice schimbare a acestei politici, cu data ei. Versiunea în vigoare: 25.10.2026.'
    }
];

function PoliticaConfidentialitate() {
    return (
        <LegalPage
            eyebrow="Informații legale"
            title="Politica de confidențialitate"
            intro="Datele medicale sunt cele mai sensibile date pe care ni le poate încredința cineva. Mai jos vă spunem ce date prelucrăm, de ce, cât timp și cui le arătăm — și ce drepturi aveți."
            sections={sections}
            footnote="EVOO-COM-MAN-01-R3 · versiunea din 25.10.2026"
        />
    );
}

export default PoliticaConfidentialitate;
